function importAll (r) {
    r.keys().forEach(r);
  }
  
  window.$ = $
  window.jQuery = $
  import 'jquery.scrollto'
  import Rails from "@rails/ujs"
  Rails.start()
  
  import 'slick-carousel'
  import 'slick-carousel/slick/slick.css'
  import "jquery-colorbox"
  
  importAll(require.context('panasonic/images', true))
  import 'normalize.css'
  import 'panasonic/styles/panasonic.sass'
  import 'scrolldepth/jquery.scrolldepth.min.js'